<template>
  <div id="app">
    <div class="header">
      <div class="flex">
        <input
          v-model="titleCampaign"
          placeholder="Nova Campanha"
          class="height-default"
        />
        <woot-button
          class="height-default"
          :disabled="!titleCampaign"
          @click="handleNodeChange"
        >
          {{ $t('CAMPAIGN_FLOW.HEADER.BUTTON_ADD') }}
        </woot-button>
      </div>

      <button
        :class="[
          'height-default',
          'button',
          enabled ? 'enableCampaignOn' : 'enableCampaignOff',
        ]"
        @click="handleEnableCampaign"
      >
        {{ enableLabel }}
      </button>
    </div>
    <div class="card-actions">
      <span class="ca-label">Adicionar nó</span>
      <woot-button class="add-card-btn" icon="add" @click="addCard('simple')">
        {{ $t('CAMPAIGN_FLOW.CONDITIONS.SIMPLE') }}
      </woot-button>
      <woot-button
        class="add-card-btn"
        icon="flash-settings"
        @click="addCard('multiple')"
      >
        {{ $t('CAMPAIGN_FLOW.CONDITIONS.MULTIPLE') }}
      </woot-button>
      <woot-button class="add-card-btn" icon="chat" @click="addCard('message')">
        {{ $t('CAMPAIGN_FLOW.CONDITIONS.MESSAGE_TRIGGER') }}
      </woot-button>
    </div>
    <div id="diagramContainer" class="diagram-container">
      <woot-context-menu
        v-if="showContextMenu"
        :x="contextMenuPosition.x"
        :y="contextMenuPosition.y"
        @close="handleClose"
      >
        <div class="menu-container">
          <menu-item
            v-if="selectedNode.type !== 'start'"
            :option="{
              icon: 'delete',
              label: $t('CAMPAIGN_FLOW.DELETE.BUTTON_TEXT'),
            }"
            variant="icon"
            @click="deleteCard"
          />
          <menu-item
            :option="{
              icon: 'settings',
              label: $t('CAMPAIGN_FLOW.CREATE.BUTTON_SETTINGS'),
            }"
            variant="icon"
            @click="onSettingsCard"
          />
        </div>
      </woot-context-menu>

      <div id="canvasInner" class="canvas-inner" :style="zoomStyle">
      <div
        v-for="node in cards"
        :id="node.id"
        :key="node.id"
        class="diagram-card"
        :style="{ top: node.top, left: node.left }"
      >
        <div :class="['node-default', node.type]">
          <span class="nh-ico">
            <fluent-icon :icon="nodeIcon(node.type)" size="15" />
          </span>
          <span
            v-if="!node.editingTitle"
            class="nh-title"
            @click="editTitle(node)"
            >{{ node.label }}</span
          >
          <input
            v-else
            class="nh-input"
            v-model="node.tempTitle"
            @keyup.enter="saveTitle(node)"
            @blur="saveTitle(node)"
          />

          <button class="nh-menu" @click.stop="openContextMenu($event, node)">
            <fluent-icon
              icon="more-vertical"
              size="16"
              class="context-menu-trigger"
            />
          </button>
        </div>

        <div class="card-content">
          <span v-if="node.content">{{ node.content }}</span>
          <div v-if="node.type == 'multiple' || node.type == 'simple'">
            <div v-for="filter in node.filters" :key="filter.id">
              <span>{{
                 $t(
                   `CONTACTS_FILTER.ATTRIBUTES.${filter.attribute_key.toUpperCase()}`
                 )
               }}
                {{
                  $t(
                    `CONTACTS_FILTER.OPERATOR_LABELS.${filter.filter_operator}`
                  )
                }}
                {{ filter.values }}</span>
            </div>
          </div>
          <div v-if="node.list_contacts_id" class="card-list">
            <fluent-icon icon="people" size="16" class="context-menu-trigger" />
            {{ node.list_contacts_name }}: {{ node.list_count }}
          </div>
        </div>
      </div>
      </div>
    </div>

    <div class="cf-legend">
      <span class="lg"><span class="sw" style="background:#002136" /> Início</span>
      <span class="lg"><span class="sw" style="background:#d98014" /> Condição simples</span>
      <span class="lg"><span class="sw" style="background:#7a5cf0" /> Condições múltiplas</span>
      <span class="lg"><span class="sw" style="background:#1f9d63" /> Mensagem</span>
    </div>
    <div class="cf-zoom">
      <button title="Aproximar" @click="zoomIn">
        <svg viewBox="0 0 24 24" class="zic"><path d="M12 5v14M5 12h14" /></svg>
      </button>
      <button title="Afastar" @click="zoomOut">
        <svg viewBox="0 0 24 24" class="zic"><path d="M5 12h14" /></svg>
      </button>
      <button title="Restaurar zoom" @click="zoomReset">
        <svg viewBox="0 0 24 24" class="zic"><path d="M8 3H5a2 2 0 0 0-2 2v3M16 3h3a2 2 0 0 1 2 2v3M21 16v3a2 2 0 0 1-2 2h-3M3 16v3a2 2 0 0 0 2 2h3" /></svg>
      </button>
    </div>

    <modal-start-settings
      v-if="showStartSettings"
      :show="showStartSettings"
      :on-close="toggleModalStartSettings"
      :list.sync="listContacts"
      :list-id="listId"
      :trigger-selected="triggerId"
      :scheduled-at-selected="scheduledAt"
      :delay-selected="delay"
      @handle-submit="handleConfigStartCard"
    />

    <woot-modal
      :show.sync="showFiltersModal"
      :on-close="closeAdvanceFiltersModal"
      size="medium"
    >
      <modal-simple-condition
        v-if="showFiltersModal"
        :on-close="closeAdvanceFiltersModal"
        :initial-filter-types="contactFilterItems"
        :initial-applied-filters="appliedFilter"
        :active-segment-name="null"
        :is-segments-view="null"
        @applyFilter="onApplyFilter"
        @clearFilters="clearFilters"
      />
    </woot-modal>

    <woot-modal
      :show.sync="showMultipleFiltersModal"
      :on-close="closeModalMultipleConditions"
      size="medium"
    >
      <modal-multiple-conditions
        v-if="showMultipleFiltersModal"
        :on-close="closeModalMultipleConditions"
        :initial-filter-types="contactFilterItems"
        :initial-applied-filters="appliedFilter"
        :active-segment-name="null"
        :is-segments-view="null"
        @applyFilter="onApplyFilter"
        @clearFilters="clearFilters"
      />
    </woot-modal>

    <modal-message
      v-if="showMessageModal"
      :show="showMessageModal"
      :on-close="closeMessageModal"
      :content="messageContent"
      :delay="delay"
      :inbox-id="inboxId"
      @add="onAddMessage"
    />

    <hire-plan-modal
      :show-modal="showPlanHireModal"
      :integration="integration"
      @hide-modal-hire-plan="closeModalHirePlan"
    />
  </div>
</template>
<script>
import { jsPlumb } from 'jsplumb';
import MenuItem from '../../../../components/widgets/conversation/contextMenu/menuItem.vue';
import ModalStartSettings from './ModalStartSettings.vue';
import { mapGetters } from 'vuex';
import contactFilterItems from '../components/contactFilterItems/index';
import ModalSimpleCondition from './ModalSimpleCondition.vue';
import ModalMultipleConditions from './ModalMultipleConditions.vue';
import ModalMessage from './ModalMessage.vue';
import HirePlanModal from '../../settings/integrationapps/HirePlanModal.vue';

export default {
  components: {
    MenuItem,
    ModalStartSettings,
    ModalSimpleCondition,
    ModalMultipleConditions,
    ModalMessage,
    HirePlanModal,
  },
  data() {
    return {
      instance: jsPlumb.getInstance(),
      cards: [
        {
          id: this.generateId(),
          label: 'Start',
          top: '50px',
          left: '50px',
          type: 'start',
          content: '',
          editingTitle: false,
          editingContent: false,
          tempTitle: '',
          tempContent: '',
          filters: [],
        },
      ],
      edges: [],
      titleCampaign: '',
      contextMenuPosition: { x: null, y: null },
      showContextMenu: false,
      selectedNode: null,
      showStartSettings: false,
      listId: null,
      showFiltersModal: false,
      showMultipleFiltersModal: false,
      appliedFilter: [],
      filterConnections: [],
      showMessageModal: false,
      messageContent: '',
      inboxId: null,
      delay: null,
      triggerId: null,
      scheduledAt: null,
      contactFilterItems: contactFilterItems.map(filter => ({
        ...filter,
        attributeName: this.$t(
          `CONTACTS_FILTER.ATTRIBUTES.${filter.attributeI18nKey}`
        ),
      })),
      enabled: true,
      showPlanHireModal: false,
      canvasZoom: 1,
    };
  },
  computed: {
    ...mapGetters({
      listContacts: 'campaignsContactList/getList',
      getAccount: 'accounts/getAccount',
      currentAccountId: 'getCurrentAccountId',
    }),

    integration() {
      return { id: 'campaign_flow', name: this.$t('CAMPAIGN_FLOW.TITLE') };
    },
    account() {
      return this.getAccount(this.currentAccountId);
    },

    enableLabel() {
      return this.enabled
        ? this.$t('CAMPAIGN_FLOW.ENABLE.ENABLED')
        : this.$t('CAMPAIGN_FLOW.ENABLE.DISABLED');
    },
    zoomStyle() {
      return { transform: `scale(${this.canvasZoom})`, transformOrigin: '0 0' };
    },
  },
  mounted() {
    this.initJsPlumb();
    document.addEventListener('mousedown', this.handleGlobalMousedown, true);
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.handleGlobalMousedown, true);
  },
  methods: {
    // Sai da edição de título ao clicar fora (o jsPlumb faz preventDefault no
    // canvas, então o @blur do input não é confiável).
    handleGlobalMousedown(e) {
      const inInput = e.target && e.target.closest;
      const editingNode = this.cards.find(c => c.editingTitle);
      if (editingNode && (!inInput || !e.target.closest('.nh-input'))) {
        this.saveTitle(editingNode);
      }
    },
    setZoom(z) {
      this.canvasZoom = Math.max(0.4, Math.min(1.4, Math.round(z * 100) / 100));
      if (this.instance && this.instance.setZoom) {
        this.instance.setZoom(this.canvasZoom);
      }
    },
    zoomIn() {
      this.setZoom(this.canvasZoom + 0.1);
    },
    zoomOut() {
      this.setZoom(this.canvasZoom - 0.1);
    },
    zoomReset() {
      this.setZoom(1);
    },
    handleEnableCampaign() {
      this.enabled = !this.enabled;
    },
    clearFilters() {
      this.appliedFilter = [];
      const card = this.cards.find(obj => obj?.id === this.selectedNode?.id);
      if (card) {
        Object.assign(card, {
          filters: [],
        });
      }
    },

    nodeIcon(type) {
      return (
        {
          start: 'people',
          simple: 'filter',
          multiple: 'flash-settings',
          message: 'chat',
        }[type] || 'flash-settings'
      );
    },

    getCommonEndpoint(type) {
      const maxConnections = type === 'multiple' ? -1 : 1;
      return {
        isSource: true,
        isTarget: true,
        maxConnections: maxConnections,
        endpoint: ['Dot', { radius: 7 }],
        paintStyle: { fill: '#ffffff', stroke: '#01c6d8', strokeWidth: 2.5 },
        hoverPaintStyle: { fill: '#01c6d8', stroke: '#0a7581', radius: 9 },
        connector: ['Bezier', { curviness: 55 }],
        connectorStyle: {
          stroke: '#01c6d8',
          strokeWidth: 2.4,
          outlineWidth: 16,
          outlineStroke: 'rgba(0,0,0,0.001)',
        },
        connectorHoverStyle: { stroke: '#0a7581', strokeWidth: 3.2 },
        overlays: [
          ['Arrow', { location: 1, width: 9, length: 11, foldback: 0.75 }],
        ],
      };
    },

    onSettingsCard() {
      if (this.selectedNode.type === 'start') {
        this.showStartSettings = true;
      } else if (this.selectedNode.type === 'multiple') {
        this.showMultipleFiltersModal = true;
      } else if (this.selectedNode.type === 'simple') {
        this.showFiltersModal = true;
      } else {
        this.showMessageModal = true;
      }
      this.closeContextMenu();
    },

    closeAdvanceFiltersModal() {
      this.showFiltersModal = false;
      this.appliedFilter = [];
    },
    onApplyFilter(filters) {
      const card = this.cards.find(obj => obj?.id === this.selectedNode?.id);
      if (card) {
        const uniqueFilters = filters.map(filter => ({
          ...filter,
          originalId: filter.id,
          id: `${this.selectedNode.id}-${filter.id}`,
        }));

        Object.assign(card, {
          filters: uniqueFilters,
        });
      }

      this.appliedFilter = filters;
      this.showFiltersModal = false;
      this.showMultipleFiltersModal = false;

      const existingFilterIds = this.filterConnections
        .filter(connection => connection.cardId === this.selectedNode.id)
        .map(connection => connection.filterId);

      const newFilterIds = filters.map(
        filter => `${this.selectedNode.id}-${filter.id}`
      );

      const removedFilterIds = existingFilterIds.filter(
        id => !newFilterIds.includes(id)
      );

      removedFilterIds.forEach(filterId => {
        this.instance.deleteEndpoint(filterId);
        this.filterConnections = this.filterConnections.filter(
          connection => connection.filterId !== filterId
        );
      });

      if (filters.length > 0 && this.selectedNode.type === 'multiple') {
        const commonEndpoint = this.getCommonEndpoint(this.selectedNode.type);

        for (let index = 0; index < filters.length; index++) {
          const filter = filters[index];
          const uniqueFilterId = `${this.selectedNode.id}-${filter.id}`;
          const position = (index + 1) / (filters.length + 1);

          if (!existingFilterIds.includes(uniqueFilterId)) {
            this.instance.addEndpoint(this.selectedNode?.id, {
              anchor: [1, position],
              ...{
                ...commonEndpoint,
                paintStyle: { fill: filter.colorConnection, radius: 4 },
                uuid: uniqueFilterId,
              },
            });

            this.filterConnections.push({
              cardId: this.selectedNode.id,
              filterId: uniqueFilterId,
              originalFilterId: filter.id,
              filter: filter,
              anchor: [1, position],
            });
          }
        }

        this.instance.addEndpoint(this.selectedNode?.id, {
          anchor: 'Bottom',
          ...{ ...commonEndpoint, paintStyle: { fill: '#ff0000', radius: 4 } },
        });
      }

      this.$nextTick(() => {
        this.instance.repaintEverything();
      });
    },

    onAddMessage({ content, inbox_id, delay, template }) {
      const card = this.cards.find(obj => obj?.id === this.selectedNode?.id);
      if (card) {
        Object.assign(card, {
          content,
          inbox_id,
          delay,
          template,
        });
      }
      this.showMessageModal = false;
    },

    closeMessageModal() {
      this.showMessageModal = false;
    },

    closeModalMultipleConditions() {
      this.showMultipleFiltersModal = false;
      this.appliedFilter = [];
    },

    handleSelectList(list) {
      const card = this.cards.find(obj => obj?.id === this.selectedNode?.id);

      if (card) {
        Object.assign(card, {
          list_contacts_id: list?.id,
          list_contacts_name: list?.name,
          list_count: list?.contacts_count,
        });
      }

      this.listId = list?.id;
      this.toggleModalStartSettings();
    },

    handleConfigStartCard({ list, triggerId, delay, scheduledAt }) {
      this.listId = list?.id;
      this.triggerId = triggerId;
      this.scheduledAt = scheduledAt;
      this.delay = delay;
      const card = this.cards.find(obj => obj?.id === this.selectedNode?.id);
      if (card) {
        Object.assign(card, {
          list_contacts_id: list?.id,
          list_contacts_name: list?.name,
          list_count: list?.contacts_count,
          trigger: triggerId,
          delay,
          scheduledAt,
        });
      }
      this.toggleModalStartSettings();
    },

    toggleModalStartSettings() {
      this.showStartSettings = !this.showStartSettings;
    },
    openContextMenu(event, node) {
      this.contextMenuPosition = { x: event.clientX, y: event.clientY };
      this.showContextMenu = true;
      this.selectedNode = node;
      if (node?.list_contacts_id) {
        this.listId = node.list_contacts_id;
      }

      if (node?.filters) {
        this.appliedFilter = node.filters.map(filter => ({
          ...filter,
          id: filter.originalId || filter.id,
        }));
      } else {
        this.appliedFilter = [];
      }

      this.messageContent = node?.content;
      this.inboxId = node?.inbox_id;
    },

    closeContextMenu() {
      this.showContextMenu = false;
    },

    handleClose() {
      this.closeContextMenu();
    },

    deleteCard() {
      this.instance.deleteConnectionsForElement(this.selectedNode.id);

      this.instance.removeAllEndpoints(this.selectedNode.id);

      this.cards = this.cards.filter(card => card.id !== this.selectedNode.id);

      this.edges = this.edges.filter(
        edge =>
          edge.source !== this.selectedNode.id &&
          edge.target !== this.selectedNode.id
      );

      this.closeContextMenu();
      this.instance.repaintEverything();
    },
    closeModalHirePlan() {
      this.showPlanHireModal = false;
    },

    handleNodeChange() {
      if (!this.account.enable_campaign_flow) {
        this.showPlanHireModal = true;
        return;
      }
      const uniqueEdges = edges => {
        const seen = new Set();
        return edges.filter(edge => {
          const key = `${edge.source}-${edge.target}`;
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        });
      };

      const removeUnusedFields = cards => {
        return cards.map(card => {
          return {
            id: card.id,
            label: card.label,
            top: card.top,
            left: card.left,
            category: card.category,
            type: card?.type,
            content: card?.content,
            inbox_id: card?.inbox_id,
            delay: card?.delay,
            list_contacts_id: card?.list_contacts_id,
            trigger: card.trigger,
            scheduledAt: card.scheduledAt,
            filters: card?.filters,
            template: card?.template,
          };
        });
      };

      const payload = {
        audience: this.resolveAudienceId(),
        title: this.titleCampaign,
        enabled: this.enabled,
        flow: {
          cards: removeUnusedFields(this.cards),
          edges: uniqueEdges(this.edges),
          multiple_connections: this.filterConnections,
        },
      };

      this.$emit('handle-card-change', payload);
      this.cleanFields();
    },

    resolveAudienceId() {
      const startCard = this.cards.find(card => card.type === 'start');
      const audienceId = this.listId || startCard?.list_contacts_id || null;
      this.listId = audienceId;
      return audienceId;
    },

    clearStartCard() {
      const startCard = this.cards.find(card => card.label === 'Start');

      if (startCard) {
        Object.assign(startCard, {
          list_contacts_id: null,
          list_contacts_name: null,
          list_count: null,
        });
      }
      this.listId = null;
    },

    cleanFields() {
      this.titleCampaign = '';
      this.cards = this.cards.filter(card => card.label === 'Start');
      this.edges = [];
      this.instance.reset();
      this.clearStartCard();
    },

    generateId() {
      return `${Date.now()}-${Math.random()
        .toString(36)
        .substr(2, 9)}`;
    },

    updateNodePosition(nodeId, pos) {
      const node = this.cards.find(n => n.id === nodeId);
      if (node) {
        node.top = `${pos[1]}px`;
        node.left = `${pos[0]}px`;
      }
    },

    addCard(type) {
      const newId = this.generateId();

      let label = '';
      if (type === 'simple') {
        label = this.$t('CAMPAIGN_FLOW.CONDITIONS.SIMPLE');
      } else if (type === 'multiple') {
        label = this.$t('CAMPAIGN_FLOW.CONDITIONS.MULTIPLE');
      } else {
        label = this.$t('CAMPAIGN_FLOW.CONDITIONS.MESSAGE_TRIGGER');
      }

      const pos = this.newNodePosition();
      const newNode = {
        id: newId,
        label: label,
        top: pos.top,
        left: pos.left,
        content: '',
        editingTitle: false,
        editingContent: false,
        tempTitle: '',
        tempContent: '',
        type: type,
        filters: [],
      };

      this.cards.push(newNode);
      this.$nextTick(() => {
        this.instance.draggable(newId, {
          stop: event => this.updateNodePosition(newId, event.pos),
        });
        this.createEndpoints(newId, type);
      });
    },
    // Posiciona o novo nó no canto superior-esquerdo da área visível.
    newNodePosition() {
      const container = document.getElementById('diagramContainer');
      const z = this.canvasZoom || 1;
      const cascade = (this.cards.length % 6) * 30;
      if (!container) {
        return { top: `${120 + cascade}px`, left: `${80 + cascade}px` };
      }
      const left = Math.round((container.scrollLeft + 48) / z + cascade);
      const top = Math.round((container.scrollTop + 36) / z + cascade);
      return { top: `${top}px`, left: `${left}px` };
    },

    createEndpoints(nodeId, type) {
      const commonEndpoint = this.getCommonEndpoint(type);

      if (type === 'multiple') {
        this.instance.addEndpoint(nodeId, {
          anchor: 'Left',
          ...commonEndpoint,
        });
      } else if (type === 'simple' || type === 'message') {
        this.instance.addEndpoint(nodeId, {
          anchor: 'Right',
          ...commonEndpoint,
        });
        this.instance.addEndpoint(nodeId, {
          anchor: 'Left',
          ...commonEndpoint,
        });
      } else {
        this.instance.addEndpoint(nodeId, {
          anchor: 'Right',
          ...commonEndpoint,
        });
      }
    },

    initJsPlumb() {
      this.instance.setContainer('canvasInner');

      this.cards.forEach(node => {
        this.instance.draggable(node.id, {
          stop: event => this.updateNodePosition(node.id, event.pos),
        });
        this.createEndpoints(node.id, node.type);
      });

      this.edges.forEach(edge => {
        this.instance.connect({
          source: edge.source,
          target: edge.target,
          connector: ['Bezier', { curviness: 55 }],
          paintStyle: { stroke: '#01c6d8', strokeWidth: 2.4, outlineWidth: 16, outlineStroke: 'rgba(0,0,0,0.001)' },
          endpointStyle: { fill: '#ffffff', stroke: '#01c6d8', strokeWidth: 2.5 },
          overlays: [
            ['Arrow', { location: 1, width: 9, length: 11, foldback: 0.75 }],
          ],
        });
      });

      this.instance.bind('connection', info => {
        const anchor = [
          info?.sourceEndpoint?.anchor?.x,
          info?.sourceEndpoint?.anchor?.y,
        ];
        const targetType = info?.targetEndpoint?.anchor?.type;
        this.edges.push({
          source: info.sourceId,
          target: info.targetId,
          anchor,
          targetType,
        });
        const findIndex = this.filterConnections.findIndex(
          connection =>
            connection.cardId === info.sourceId &&
            connection.anchor[0] === anchor[0] &&
            connection.anchor[1] === anchor[1]
        );
        if (findIndex !== -1) {
          this.filterConnections[findIndex].targetId = info.targetId;
          this.filterConnections[findIndex].targetType = targetType;
        }

        info.connection.addOverlay([
          'Arrow',
          { location: 1, width: 10, length: 10, direction: 1 },
        ]);
        this.$nextTick(() => this.applyContinuousAnchors());
      });

      this.instance.bind('connectionDetached', info => {
        this.edges = this.edges.filter(
          edge =>
            !(edge.source === info.sourceId && edge.target === info.targetId)
        );
      });

      // Deletar conexão: hover mostra "✕"; clicar na linha remove.
      this.instance.bind('mouseover', conn => {
        if (conn && conn.endpoints && conn.getOverlay && !conn.getOverlay('rm')) {
          conn.addOverlay([
            'Label',
            { label: '✕', id: 'rm', location: 0.5, cssClass: 'conn-rm' },
          ]);
        }
      });
      this.instance.bind('mouseout', conn => {
        if (conn && conn.getOverlay && conn.getOverlay('rm')) {
          conn.removeOverlay('rm');
        }
      });
      this.instance.bind('click', conn => {
        if (conn && conn.endpoints && conn.sourceId && conn.targetId) {
          this.removeConnection(conn);
        }
      });

      this.applyContinuousAnchors();
    },
    // Âncoras "Continuous": a linha sai/entra pelo lado do nó voltado para o
    // outro, reduzindo cruzamentos por cima dos cards.
    applyContinuousAnchors() {
      const faces = ['left', 'right', 'top', 'bottom'];
      try {
        this.instance.getConnections().forEach(conn => {
          conn.endpoints.forEach(ep => {
            if (ep.setAnchor) ep.setAnchor(['Continuous', { faces }], true);
          });
        });
        this.instance.repaintEverything();
      } catch (e) {
        // sem quebrar o render se a API mudar
      }
    },
    removeConnection(conn) {
      try {
        this.instance.deleteConnection(conn);
      } catch (e) {
        // já removida
      }
    },
    editTitle(node) {
      if (node.type === 'start') {
        return;
      }
      node.tempTitle = node.label;
      node.editingTitle = true;
    },

    editTitleCampaign(node) {
      node.tempTitle = node.label;
      node.editingTitle = true;
    },

    editContent(node) {
      node.tempContent = node.content;
      node.editingContent = true;
    },

    saveTitle(node) {
      node.label = node.tempTitle;
      node.editingTitle = false;
    },

    saveContent(node) {
      node.content = node.tempContent;
      node.editingContent = false;
    },

    saveNode(node) {
      this.saveTitle(node);
      this.saveContent(node);
    },

    cancelEdit(node, type) {
      if (type === 'title') node.editingTitle = false;
      else if (type === 'content') node.editingContent = false;
    },
  },
};
</script>

<style scoped>
.height-default {
  height: 3rem !important;
}

.card-actions {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  padding: 1.2rem 2.2rem;
  background: var(--white);
  border-bottom: 1px solid var(--color-border);
  flex: none;
}
.card-actions .ca-label {
  font-size: 1.1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  color: #8a97a3;
  margin-right: 0.4rem;
}

.card-actions::v-deep .add-card-btn {
  height: 3.8rem !important;
  border-radius: 1rem !important;
  background: var(--white) !important;
  color: #0f1f2a !important;
  border: 1px solid var(--color-border) !important;
  font-weight: 600;
  transition: box-shadow 0.15s, border-color 0.15s, transform 0.15s;
}
.card-actions::v-deep .add-card-btn:hover {
  border-color: var(--s-300) !important;
  box-shadow: 0 1px 2px rgba(16, 32, 45, 0.06);
  transform: translateY(-1px);
}

.menu-container {
  padding: var(--space-smaller);
  background-color: var(--white);
  box-shadow: var(--shadow-context-menu);
  border-radius: var(--border-radius-normal);
}
.menu-container hr:first-child {
  display: none;
}

.menu-container hr {
  border-bottom: 1px solid var(--color-border-light);
  margin: var(--space-smaller);
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 1.2rem;
  padding: 1.2rem 2.2rem;
  background: var(--white);
  border-bottom: 1px solid var(--color-border);
}
.header .flex {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.header input {
  height: 3.6rem;
  width: auto;
  min-width: 22rem;
  border-radius: 0.9rem;
  box-sizing: border-box;
  padding: 0 1.2rem;
  font-family: inherit;
  font-size: 1.5rem;
  font-weight: 700;
  color: #002136;
  background: var(--s-25);
  border: 1px solid var(--color-border);
  transition: border-color 0.15s, box-shadow 0.15s;
}
.header input:focus {
  outline: none;
  border-color: #01c6d8;
  box-shadow: 0 0 0 3px #e1f8fb;
  background: #fff;
}
/* botão Salvar */
.header .flex::v-deep .button {
  background: #01c6d8 !important;
  color: #fff !important;
  border-radius: 0.9rem !important;
  height: 3.6rem;
  font-weight: 700;
}
/* pílula de status Ativo/Inativo */
.enableCampaignOn,
.enableCampaignOff {
  height: 3.4rem !important;
  padding: 0 1.4rem;
  border-radius: 20px;
  font-weight: 700;
  font-size: 1.3rem;
  display: inline-flex;
  align-items: center;
  gap: 0.7rem;
  border: 0;
}
.enableCampaignOn {
  background: #e7f6ee !important;
  color: #177a4a !important;
}
.enableCampaignOff {
  background: #f0f3f5 !important;
  color: #516170 !important;
}
.enableCampaignOn::before,
.enableCampaignOff::before {
  content: '';
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 50%;
  background: currentColor;
  opacity: 0.9;
}

#app {
  position: relative;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 11rem);
}
.header {
  flex: none;
}

.diagram-container {
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  position: relative;
  background-color: var(--s-25);
  background-image: radial-gradient(circle, #dbe2e8 1.1px, transparent 1.1px);
  background-size: 22px 22px;
  background-position: -1px -1px;
}

.canvas-inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 5000px;
  height: 3500px;
  transform-origin: 0 0;
}

::v-deep .jtk-endpoint {
  cursor: crosshair;
  z-index: 5;
}
::v-deep .jtk-connector {
  cursor: pointer;
}
::v-deep .jtk-connector:hover path {
  stroke-width: 3.2;
}
::v-deep .conn-rm {
  display: grid;
  place-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: #dc4b4b;
  color: #fff;
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1;
  box-shadow: 0 1px 4px rgba(16, 32, 45, 0.35);
  border: 2px solid #fff;
  pointer-events: none;
  z-index: 6;
}

.cf-legend {
  position: absolute;
  left: 1.6rem;
  bottom: 1.4rem;
  display: flex;
  gap: 1.4rem;
  background: var(--white);
  border: 1px solid var(--color-border);
  border-radius: 10px;
  padding: 0.9rem 1.3rem;
  z-index: 20;
  box-shadow: 0 1px 2px rgba(16, 32, 45, 0.08);
}
.cf-legend .lg {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 1.1rem;
  font-weight: 600;
  color: #516170;
}
.cf-legend .sw {
  width: 1.1rem;
  height: 1.1rem;
  border-radius: 4px;
}
.cf-zoom {
  position: absolute;
  right: 1.6rem;
  bottom: 1.4rem;
  display: flex;
  flex-direction: column;
  background: var(--white);
  border: 1px solid var(--color-border);
  border-radius: 10px;
  overflow: hidden;
  z-index: 20;
  box-shadow: 0 1px 2px rgba(16, 32, 45, 0.08);
}
.cf-zoom button {
  width: 3.6rem;
  height: 3.4rem;
  display: grid;
  place-items: center;
  color: #516170;
  background: transparent;
  border: 0;
  cursor: pointer;
}
.cf-zoom button:hover {
  background: var(--s-25);
  color: #002136;
}
.cf-zoom button + button {
  border-top: 1px solid var(--color-border);
}
.cf-zoom .zic {
  width: 1.8rem;
  height: 1.8rem;
  stroke: currentColor;
  stroke-width: 2;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
}

/* .multiple {
  width: 200px !important;
  height: 210px !important;
  font-weight: bold;

  clip-path: polygon(
    30% 0%, 70% 0%,
    100% 30%, 100% 70%,
    70% 100%, 30% 100%,
    0% 70%, 0% 30%
  );
} */

.diagram-card {
  background: var(--white);
  position: absolute;
  width: 236px;
  height: fit-content;
  border: 1px solid var(--color-border);
  border-radius: 13px;
  padding: 0;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(16, 32, 45, 0.1);
  transition: box-shadow 0.15s;
  /* card acima das linhas de conexão (a linha passa por trás do card) */
  z-index: 2;
}
.diagram-card:hover {
  box-shadow: 0 12px 40px rgba(16, 32, 45, 0.16);
}

/* cabeçalho do nó (colorido por tipo) */
.node-default {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  text-align: left;
  cursor: pointer;
  padding: 0.9rem 1rem;
  border-bottom: 1px solid var(--color-border);
}
.node-default .nh-ico {
  width: 2.6rem;
  height: 2.6rem;
  border-radius: 8px;
  display: grid;
  place-items: center;
  flex: none;
  color: #fff;
}
.node-default .nh-title {
  flex: 1;
  min-width: 0;
  font-size: 1.3rem;
  font-weight: 750;
  color: #002136;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.node-default .nh-input {
  flex: 1;
  min-width: 0;
  font-size: 1.3rem;
  border: 1px solid var(--color-border);
  border-radius: 6px;
  padding: 0.3rem 0.6rem;
}
.node-default .nh-menu {
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 7px;
  display: grid;
  place-items: center;
  flex: none;
  color: #8a97a3;
  background: transparent;
  border: 0;
}
.node-default .nh-menu:hover {
  background: rgba(0, 33, 54, 0.06);
  color: #002136;
}

.start {
  background: #eef2f4;
}
.start .nh-ico {
  background: #002136;
}
.simple {
  background: #fdf2e2;
}
.simple .nh-ico {
  background: #d98014;
}
.multiple {
  background: #f0ecfe;
}
.multiple .nh-ico {
  background: #7a5cf0;
}
.message {
  background: #e7f6ee;
}
.message .nh-ico {
  background: #1f9d63;
}

/* corpo do nó */
.card-content {
  padding: 1.1rem 1.3rem 1.2rem;
  color: #516170;
  font-size: 1.25rem;
  font-weight: 500;
  word-break: break-word;
  line-height: 1.4;
}
.card-content > span:first-child {
  color: #002136;
}

.card-list {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  margin-top: 0.9rem;
  padding: 0.4rem 0.9rem;
  border-radius: 20px;
  background: var(--s-25);
  font-size: 1.15rem;
  font-weight: 600;
  color: #516170;
  justify-content: flex-start;
}

.nh-input {
  border: 1px solid #ccc;
  padding: 3px;
}
</style>
